import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization, organizationFactory } from '@/types/organization';

import { Session } from '@/types/session';
import { Admin, adminFactory } from '@/types/admin';
import * as asyncActions from './asyncActions';
import { Affiliation } from '@/types/affiliation';
import { PURGE } from 'redux-persist';

type State = {
  session: Session | null;
  current: {
    isLoggedIn: boolean;
    organization: Organization;
    me: Admin;
    role: 'member' | 'manager';
  };
};

export const initialState: State = {
  session: null,
  current: {
    isLoggedIn: false,
    organization: organizationFactory(),
    me: adminFactory(),
    role: 'member',
  },
};

// MEMO: reducer selectOrganizationはOIDC移行でなくなる

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsLoggedIn(state) {
      state.current.isLoggedIn = true;
    },
    setSession(state, action: PayloadAction<Session | null>) {
      state.current.isLoggedIn = action.payload === null ? false : true;
      state.session = action.payload;
    },
    updateMe(state, action: PayloadAction<Admin>) {
      state.current.me = action.payload;
    },
    updateCurrent(state, action: PayloadAction<State['current']>) {
      state.current = action.payload;
    },
    logoutForOrganizationsForSelect() {
      return initialState;
    },
    selectOrganization(state, action: PayloadAction<Affiliation>) {
      const affiliation = action.payload;

      state.current = {
        isLoggedIn: state.current.isLoggedIn,
        organization: affiliation.organization,
        me: affiliation.admin,
        role: affiliation.role,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.logout.fulfilled, () => {
        return initialState;
      })
      .addCase(PURGE, () => {
        return initialState;
      });
  },
});

export const actions = slice.actions;
export default slice.reducer;
